/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as EventsRouteImport } from './routes/events'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as EventsEventIdRouteImport } from './routes/events.$eventId'
import { Route as ProtectedProfileRouteImport } from './routes/_protected/profile'
import { Route as ProtectedEventRouteImport } from './routes/_protected/event'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected/dashboard'
import { Route as ProtectedAdminRouteImport } from './routes/_protected/admin'
import { Route as ProtectedAdminUsersRouteImport } from './routes/_protected/admin.users'
import { Route as ProtectedAdminReportsRouteImport } from './routes/_protected/admin.reports'
import { Route as ProtectedAdminEventsRouteImport } from './routes/_protected/admin.events'
import { Route as ProtectedAdminAttendeesRouteImport } from './routes/_protected/admin.attendees'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsRoute = EventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EventsRoute,
} as any)
const EventsEventIdRoute = EventsEventIdRouteImport.update({
  id: '/$eventId',
  path: '/$eventId',
  getParentRoute: () => EventsRoute,
} as any)
const ProtectedProfileRoute = ProtectedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedEventRoute = ProtectedEventRouteImport.update({
  id: '/event',
  path: '/event',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAdminRoute = ProtectedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAdminUsersRoute = ProtectedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => ProtectedAdminRoute,
} as any)
const ProtectedAdminReportsRoute = ProtectedAdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => ProtectedAdminRoute,
} as any)
const ProtectedAdminEventsRoute = ProtectedAdminEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => ProtectedAdminRoute,
} as any)
const ProtectedAdminAttendeesRoute = ProtectedAdminAttendeesRouteImport.update({
  id: '/attendees',
  path: '/attendees',
  getParentRoute: () => ProtectedAdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/contact': typeof ContactRoute
  '/events': typeof EventsRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/admin': typeof ProtectedAdminRouteWithChildren
  '/dashboard': typeof ProtectedDashboardRoute
  '/event': typeof ProtectedEventRoute
  '/profile': typeof ProtectedProfileRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/events/': typeof EventsIndexRoute
  '/admin/attendees': typeof ProtectedAdminAttendeesRoute
  '/admin/events': typeof ProtectedAdminEventsRoute
  '/admin/reports': typeof ProtectedAdminReportsRoute
  '/admin/users': typeof ProtectedAdminUsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contact': typeof ContactRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/admin': typeof ProtectedAdminRouteWithChildren
  '/dashboard': typeof ProtectedDashboardRoute
  '/event': typeof ProtectedEventRoute
  '/profile': typeof ProtectedProfileRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/events': typeof EventsIndexRoute
  '/admin/attendees': typeof ProtectedAdminAttendeesRoute
  '/admin/events': typeof ProtectedAdminEventsRoute
  '/admin/reports': typeof ProtectedAdminReportsRoute
  '/admin/users': typeof ProtectedAdminUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/contact': typeof ContactRoute
  '/events': typeof EventsRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/_protected/admin': typeof ProtectedAdminRouteWithChildren
  '/_protected/dashboard': typeof ProtectedDashboardRoute
  '/_protected/event': typeof ProtectedEventRoute
  '/_protected/profile': typeof ProtectedProfileRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/events/': typeof EventsIndexRoute
  '/_protected/admin/attendees': typeof ProtectedAdminAttendeesRoute
  '/_protected/admin/events': typeof ProtectedAdminEventsRoute
  '/_protected/admin/reports': typeof ProtectedAdminReportsRoute
  '/_protected/admin/users': typeof ProtectedAdminUsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contact'
    | '/events'
    | '/login'
    | '/signup'
    | '/admin'
    | '/dashboard'
    | '/event'
    | '/profile'
    | '/events/$eventId'
    | '/events/'
    | '/admin/attendees'
    | '/admin/events'
    | '/admin/reports'
    | '/admin/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contact'
    | '/login'
    | '/signup'
    | '/admin'
    | '/dashboard'
    | '/event'
    | '/profile'
    | '/events/$eventId'
    | '/events'
    | '/admin/attendees'
    | '/admin/events'
    | '/admin/reports'
    | '/admin/users'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/contact'
    | '/events'
    | '/login'
    | '/signup'
    | '/_protected/admin'
    | '/_protected/dashboard'
    | '/_protected/event'
    | '/_protected/profile'
    | '/events/$eventId'
    | '/events/'
    | '/_protected/admin/attendees'
    | '/_protected/admin/events'
    | '/_protected/admin/reports'
    | '/_protected/admin/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  ContactRoute: typeof ContactRoute
  EventsRoute: typeof EventsRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/': {
      id: '/events/'
      path: '/'
      fullPath: '/events/'
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof EventsRoute
    }
    '/events/$eventId': {
      id: '/events/$eventId'
      path: '/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof EventsEventIdRouteImport
      parentRoute: typeof EventsRoute
    }
    '/_protected/profile': {
      id: '/_protected/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProtectedProfileRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/event': {
      id: '/_protected/event'
      path: '/event'
      fullPath: '/event'
      preLoaderRoute: typeof ProtectedEventRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/admin': {
      id: '/_protected/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof ProtectedAdminRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/admin/users': {
      id: '/_protected/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof ProtectedAdminUsersRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/reports': {
      id: '/_protected/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof ProtectedAdminReportsRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/events': {
      id: '/_protected/admin/events'
      path: '/events'
      fullPath: '/admin/events'
      preLoaderRoute: typeof ProtectedAdminEventsRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/attendees': {
      id: '/_protected/admin/attendees'
      path: '/attendees'
      fullPath: '/admin/attendees'
      preLoaderRoute: typeof ProtectedAdminAttendeesRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
  }
}

interface ProtectedAdminRouteChildren {
  ProtectedAdminAttendeesRoute: typeof ProtectedAdminAttendeesRoute
  ProtectedAdminEventsRoute: typeof ProtectedAdminEventsRoute
  ProtectedAdminReportsRoute: typeof ProtectedAdminReportsRoute
  ProtectedAdminUsersRoute: typeof ProtectedAdminUsersRoute
}

const ProtectedAdminRouteChildren: ProtectedAdminRouteChildren = {
  ProtectedAdminAttendeesRoute: ProtectedAdminAttendeesRoute,
  ProtectedAdminEventsRoute: ProtectedAdminEventsRoute,
  ProtectedAdminReportsRoute: ProtectedAdminReportsRoute,
  ProtectedAdminUsersRoute: ProtectedAdminUsersRoute,
}

const ProtectedAdminRouteWithChildren = ProtectedAdminRoute._addFileChildren(
  ProtectedAdminRouteChildren,
)

interface ProtectedRouteChildren {
  ProtectedAdminRoute: typeof ProtectedAdminRouteWithChildren
  ProtectedDashboardRoute: typeof ProtectedDashboardRoute
  ProtectedEventRoute: typeof ProtectedEventRoute
  ProtectedProfileRoute: typeof ProtectedProfileRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedAdminRoute: ProtectedAdminRouteWithChildren,
  ProtectedDashboardRoute: ProtectedDashboardRoute,
  ProtectedEventRoute: ProtectedEventRoute,
  ProtectedProfileRoute: ProtectedProfileRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

interface EventsRouteChildren {
  EventsEventIdRoute: typeof EventsEventIdRoute
  EventsIndexRoute: typeof EventsIndexRoute
}

const EventsRouteChildren: EventsRouteChildren = {
  EventsEventIdRoute: EventsEventIdRoute,
  EventsIndexRoute: EventsIndexRoute,
}

const EventsRouteWithChildren =
  EventsRoute._addFileChildren(EventsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  ContactRoute: ContactRoute,
  EventsRoute: EventsRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
